import { Navigate, useParams } from "src/router";

export const RedirectWithWildcard = ({ path }: { path: string }) => {
  const { "*": wildcard } = useParams();

  return <Navigate to={`${path}/${wildcard || ""}`} replace />;
};
